export const OCR_ENGINES = {
    TESSERACT: 'tesseract',
    PADDLE: 'paddle',
};

export const OCR_ENGINE_LABELS = {
    [OCR_ENGINES.TESSERACT]: 'Tesseract (Speed)',
    [OCR_ENGINES.PADDLE]: 'PaddleOCR (Quality)',
};
